export default "__VITE_ASSET__DCd1lV9f__";